<template>
  <div>
    <BurgerMenuIcon @toggle="toggleMenu"/>
    <ClientOnly fallback-tag="div">
      <LazyDialog
          v-model:visible="menuVisible"
          :showHeader="false"
          position="right"
          :block-scroll="true"
          :modal="true"
          :draggable="false"
          class="mobile-menu-dialog"
      >
        <template #container>
          <div class="mobile-menu-container">
            <div class="mobile-menu-dialog-header">
              <nuxt-link to="/" class="site-header__logo" @click="menuVisible = false">
                <span class="text-title-1 fw-bold" v-if="$siteConfig.brand ==='BookDirect'">
                  BOOK<span class="color-blue">DIRECT</span><span class="color-dark-grey">.COM</span>
                </span>
                <span v-else-if="$siteConfig.logoHasWordmark" class="brand-logo">
                  <img class="brand-logo__img brand-logo__img--light" :src="$siteConfig.logo" width="164" height="48" :alt="$siteConfig.brand">
                  <img v-if="$siteConfig.logoDark" class="brand-logo__img brand-logo__img--dark" :src="$siteConfig.logoDark" width="164" height="48" :alt="$siteConfig.brand">
                </span>
                <span class="text-title-2 fw-bold other-logos" v-else>
                  <img
                    :src="$siteConfig.logo"
                    :width="$siteConfig.brand === 'Solaire' ? 126 : 36"
                    :height="$siteConfig.brand === 'Solaire' ? 63 : 24"
                    :style="$siteConfig.brand === 'Solaire' ? 'width:auto;height:clamp(44px,8vw,63px);object-fit:contain;display:block;padding:0;margin:0' : ''"
                    :alt="$siteConfig.brand"
                  >
                  <span v-if="$siteConfig.brand !== 'Solaire'">{{$siteConfig.brand}}</span>
                </span>
              </nuxt-link>
              <button class="mobile-menu-close" aria-label="Close menu" @click="menuVisible = false">
                <span class="icon icon-close"></span>
              </button>
            </div>
            <div class="mobile-menu">
              <CurrencySelector class="mobile-menu__item"/>
              <LanguageSelector class="mobile-menu__item"/>
              <button v-if="$siteConfig.brand !== 'Solaire'" class="mobile-menu__item theme-toggle-mobile" @click="toggle">
                <svg v-if="theme === 'dark'" class="theme-toggle-mobile__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
                <svg v-else class="theme-toggle-mobile__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
                <span class="theme-toggle-mobile__label">{{ preference === 'system' ? 'System theme' : preference === 'dark' ? 'Dark mode' : 'Light mode' }}</span>
              </button>
              <div class="mobile-menu__divider"></div>
              <SiteHeaderMenu class="mobile-menu__item--sign-in"/>
            </div>
          </div>
        </template>
      </LazyDialog>
    </ClientOnly>

  </div>
  <!-- Rest of your template -->
</template>
<script setup lang="ts">
import BurgerMenuIcon from './BurgerMenuIcon.vue'
import { useTheme } from '~/composables/useTheme'
const { $siteConfig } = useNuxtApp()
const { theme, preference, toggle } = useTheme()

const menuVisible = ref(false);

function toggleMenu() {
  menuVisible.value = !menuVisible.value;
}

</script>



<style scoped lang="scss">
:global(.mobile-menu-dialog) {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  background: var(--white);

  .p-dialog-content {
    background: var(--white);
  }
}

:global(.mobile-menu-container) {
  background: var(--white);
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

:global(.mobile-menu-dialog-header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--page-horizontal-padding);
  height: 60px;
  border-bottom: 1px solid var(--grey-border);
}

.mobile-menu-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--light-grey);
  cursor: pointer;
  transition: background 0.15s ease;

  .icon {
    font-size: 12px;
    color: var(--dark-grey);
  }

  &:hover {
    background: var(--grey-border);
  }
}

.other-logos {
  display: flex;
  gap: 8px;
}

:global(.mobile-menu-dialog-header--return) {
  gap: 16px;
  font-size: 17px;
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  padding: 0 var(--page-horizontal-padding);
  height: 60px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: var(--light-grey);
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: var(--grey-border);
    }

    .icon {
      font-size: 14px;
    }
  }
}

.mobile-menu {
  padding: 12px var(--page-horizontal-padding) 24px;
  display: flex;
  flex-direction: column;
  row-gap: 4px;

  &__item {
    display: flex;
    width: 100%;
    max-width: 100%;
    min-height: 48px;
    padding: 12px 16px;
    gap: 12px;
    border-radius: 10px;
    justify-content: space-between;
    align-items: center;
    transition: background 0.15s ease;

    &--sign-in {
      border-left: none;
      padding: 4px 0 0;

      :deep(.header-menu) {
        border-left: none;
        padding-left: 0;
      }

      :deep(button) {
        font-size: 14px;
        font-weight: 600;
        padding: 12px 16px;
        border-radius: 10px;
        width: 100%;
        text-align: left;

        &:hover {
          background: var(--blue-highlight);
        }
      }
    }

    &:hover {
      background: var(--light-grey);
    }

    &.currency-selector, &.language-selector {
      display: flex;
      justify-content: space-between;
    }
  }

  &__divider {
    height: 1px;
    background: var(--grey-border);
    margin: 8px 0;
  }

  .theme-toggle-mobile {
    background: transparent;
    border: none;
    color: var(--black);
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;

    &__icon {
      color: var(--dark-grey);
      flex-shrink: 0;
      width: 20px;
    }

    &__label {
      flex: 1;
      text-align: left;
      font-weight: 500;
    }
  }
}

@media (max-width: 480px) {
  :global(.mobile-menu-dialog-header) {
    padding: 0 16px;
  }

  .mobile-menu {
    padding: 12px 16px 24px;

    &__item {
      padding: 12px 12px;
    }
  }
}
</style>
